import { useRef, useState } from "react";
import { Loader2, Upload } from "lucide-react";
import { OVERLINE, H1, btnPrimary } from "@/components/admin/ui";
import { MediaThumb, useMediaLibrary } from "@/components/cms/MediaPicker";
import { mediaSrc } from "@/lib/api";

export default function AdminMedia() {
  const [kind, setKind] = useState("");
  const { items, uploading, upload, remove } = useMediaLibrary(kind || undefined);
  const fileRef = useRef(null);

  return (
    <div className="p-6 md:p-8" data-testid="admin-media">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div><p className={OVERLINE}>Website</p><h1 className={H1}>Media Library</h1></div>
        <div className="flex items-center gap-2">
          <input ref={fileRef} type="file" accept="image/*,application/pdf" className="hidden" data-testid="media-upload-file"
            onChange={(e) => { const f = e.target.files?.[0]; if (f) upload(f); e.target.value = ""; }} />
          <button onClick={() => fileRef.current?.click()} disabled={uploading} className={btnPrimary} data-testid="media-upload-btn">
            {uploading ? <Loader2 size={15} className="animate-spin" /> : <Upload size={15} />} Upload
          </button>
        </div>
      </div>

      <p className="text-sm text-[#5C6B61] mt-2 mb-4">Upload once, reuse everywhere — these images and PDFs are available in the page editor, hero image and state documents. Max 25MB each.</p>

      <div className="flex gap-2 mb-5">
        {[["", "All"], ["image", "Images"], ["pdf", "PDFs"]].map(([k, l]) => (
          <button key={k} onClick={() => setKind(k)} className={`px-3 py-1.5 text-xs border ${kind === k ? "bg-[#1F2A22] text-white border-[#1F2A22]" : "border-[#E5E2DC] text-[#5C6B61]"}`} data-testid={`media-filter-${k || "all"}`}>{l}</button>
        ))}
      </div>

      {items === null ? (
        <div className="py-16 grid place-items-center"><Loader2 className="animate-spin text-[#FF6A00]" /></div>
      ) : items.length === 0 ? (
        <p className="text-[#5C6B61] py-10">No media yet. Upload your first image or PDF.</p>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-6 gap-3" data-testid="media-grid">
          {items.map((it) => <MediaThumb key={it.id} item={it} onClick={() => window.open(mediaSrc(it.url), "_blank")} onDelete={remove} />)}
        </div>
      )}
    </div>
  );
}
